import {
  deletePositionApi,
  listOfPosition,
  updateStatusPosition,
} from "Api/role";
import BaseButton from "Components/Base/BaseButton";
import Loader from "Components/Base/BaseLoader";
import TableContainer from "Components/Base/BaseTable";
import DeleteModal from "Components/Base/DeleteModal";
import {
  checkStatusCodeSuccess,
  closeLabel,
  notFound,
  Search,
} from "Components/constants/Common";
import {
  ActionKey,
  ActionLabel,
  activateLabel,
  activeLabel,
  AuthUserPermissionLabel,
  ConfigurationLabel,
  DeleteLabel,
  editLabel,
  IdKey,
  InactivateLabel,
  InactiveLabel,
  NewLabel,
  NoLabel,
  PermissionsLabel,
  RoleKey,
  RoleLabel,
  RoleNameLabel,
  SrNoLabel,
  StatusKey,
  StatusLabel,
  StatusUpdateLabel,
  StatusUpdateMessageLabel,
  submitLabel,
  YesLabel,
} from "Components/constants/Role";
import { SetStateAction, useEffect, useMemo, useState } from "react";
import { RiSearchLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const Role = () => {
  document.title = ConfigurationLabel;
  const navigate = useNavigate();
  const [roleData, setRoleData] = useState<Array<any>>([]);
  const [searchRoleData, setSearchRoleData] = useState<Array<any>>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [btnLoader, setBtnLoader] = useState<boolean>(false);
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
  const [isActiveModal, setIsActiveModal] = useState<boolean>(false);
  const [isActiveModalState, setIsActiveModalState] = useState<string>("");
  const [activeModalId, setActiveModalId] = useState<number>();
  const [deleteId, setDeleteId] = useState<number>();
  const [totalNumberOfRows, setTotalNumberOfRows] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [columnName, setColumnName] = useState("id");
  const [sortOrder, setSortOrder] = useState("desc");
  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [customPageSize, setCustomPageSize] = useState(10);

  const handleFetchSorting = (
    page: any,
    id: SetStateAction<string>,
    order: SetStateAction<string>
  ) => {
    setCurrentPage(page);
    setColumnName(id);
    setSortOrder(order);
  };
  const handleSearchValueChange = (value: any) => {
    if (value !== searchValue) {
      setCurrentPage(1);
      setSearchValue(value);
    }
  };
  const handleFetchData = (page: any) => {
    setCurrentPage(page);
  };
  const handleDelete = (id: string) => {
    setDeleteOpen(!deleteOpen);
    setDeleteId(Number(id));
  };
  const handleActive = (id: string, state: string) => {
    setIsActiveModal(!isActiveModal);
    setActiveModalId(Number(id));
    setIsActiveModalState(state);
  };

  const columns = useMemo(
    () => [
      {
        header: SrNoLabel,
        accessorKey: IdKey,
        cell: (cell: any) =>
          (currentPage - 1) * customPageSize + (cell.row.index + 1),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: RoleNameLabel,
        accessorKey: RoleKey,
        enableColumnFilter: false,
      },
      {
        header: PermissionsLabel,
        accessorKey: AuthUserPermissionLabel,
        cell: (cell: any) => (
          <div
            className={
              cell?.row?.original?.authUserPermission.length > 5
                ? `d-flex justify-content-start flex-wrap gap-2 icon tooltip-container-data`
                : `d-flex justify-content-start flex-wrap gap-2 icon`
            }
          >
            {cell?.row?.original?.authUserPermission.length > 5
              ? cell?.row?.original?.authUserPermission
                  .slice(0, 5)
                  .map((item: any, index: number) => {
                    return (
                      <>
                        <span className="badge bg-light text-dark">
                          {item.module_name}
                        </span>
                        {index ===
                          cell?.row?.original?.authUserPermission.slice(0, 5)
                            .length -
                            1 && (
                          <span className="badge bg-light text-dark">
                            +
                            {
                              cell?.row?.original?.authUserPermission.slice(5)
                                .length
                            }
                          </span>
                        )}
                      </>
                    );
                  })
              : cell?.row?.original?.authUserPermission.map((item: any) => {
                  return (
                    <span className="badge bg-light text-dark">
                      {item.module_name}
                    </span>
                  );
                })}
            <span className="tooltip-text">
              {cell?.row?.original?.authUserPermission.map(
                (item: any, index: number) => {
                  return index ===
                    cell?.row?.original?.authUserPermission.length - 1
                    ? item.module_name
                    : `${item.module_name}, `;
                }
              )}
            </span>
          </div>
        ),
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        header: StatusLabel,
        accessorKey: StatusKey,
        enableSorting: true,
        enableColumnFilter: false,
        cell: (cell: any) => (
          <div className="d-flex justify-content-start gap-2 icon">
            {cell?.row?.original?.status ? (
              <span className="badge bg-success">{activeLabel}</span>
            ) : (
              <span className="badge bg-danger">{InactiveLabel}</span>
            )}
          </div>
        ),
      },
      {
        header: ActionLabel,
        accessorKey: ActionKey,
        cell: (cell: any) => (
          <div className="d-flex justify-content-start enable-action flex-wrap gap-2 icon">
            <span className="tooltip-container">
              <i
                className={`${
                  !cell?.row?.original?.status ? "icon-disabled" : ""
                } mdi mdi-pencil-outline fs-4 text-info cursor-pointer`}
                onClick={() => navigate(`/editrole/${cell?.row?.original?.id}`)}
              ></i>
              <span className="tooltip-text">{editLabel}</span>
            </span>

            {/* delete future purpose */}
            {/* <span className="tooltip-container">
              <i
                className="mdi mdi-delete-outline fs-4 text-danger cursor-pointer"
                onClick={() => handleDelete(cell?.row?.original?.id)}
              ></i>
              <span className="tooltip-text">{DeleteLabel}</span>
            </span> */}
            <span className="tooltip-container">
              <BaseButton
                color="link"
                onClick={() =>
                  handleActive(
                    cell?.row?.original?.id,
                    cell?.row?.original?.status
                  )
                }
                className="py-0 px-1 shadow-none"
                children={
                  !cell?.row?.original?.status ? (
                    <i className="mdi mdi-check text-success fs-4"></i>
                  ) : (
                    <i className="mdi mdi-close text-danger fs-4"></i>
                  )
                }
              />
              <span className="tooltip-text">
                {cell?.row?.original?.status ? InactivateLabel : activateLabel}
              </span>
            </span>
          </div>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
    ],
    [customPageSize, currentPage]
  );

  const handleStatusChange = () => {
    setBtnLoader(true);
    const payload = {
      status: !isActiveModalState,
    };
    updateStatusPosition(Number(activeModalId), payload)
      .then((resp) => {
        if (checkStatusCodeSuccess(resp?.statusCode)) {
          toast.success(resp?.message);
        } else {
          toast.error(resp?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || error?.message);
      })
      .finally(() => {
        setBtnLoader(false);
        setIsActiveModal(!isActiveModal);
        fetchRoleData();
      });
  };

  const deletePosition = () => {
    setBtnLoader(true);
    deletePositionApi(Number(deleteId))
      .then((resp) => {
        if (checkStatusCodeSuccess(resp?.statusCode)) {
          toast.success(resp?.message);
        } else {
          toast.error(resp?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || error?.message);
      })
      .finally(() => {
        setBtnLoader(false);
        setDeleteOpen(!deleteOpen);
        fetchRoleData();
      });
  };

  const fetchRoleData = () => {
    setLoader(true);
    const payload = {
      sortKey: columnName,
      sortValue: sortOrder,
      page: currentPage,
      limit: customPageSize,
    };
    listOfPosition(payload)
      .then((response) => {
        if (checkStatusCodeSuccess(response.statusCode)) {
          setRoleData(response.data.positions);
          setTotalRecords(response.data.totalItems);
          setTotalPages(response?.data?.totalPages);
          setTotalNumberOfRows(response?.data?.numberOfRows);
        }
      })
      .catch((error) => {
        setRoleData([]);
        return error;
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const fetchSearchRoleData = () => {
    setLoader(true);
    const payload = {
      sortKey: columnName,
      sortValue: sortOrder,
      page: currentPage,
      limit: customPageSize,
      search: searchValue,
    };
    listOfPosition(payload)
      .then((response) => {
        if (checkStatusCodeSuccess(response.statusCode)) {
          setSearchRoleData(response.data.positions);
          setTotalRecords(response.data.totalItems);
          setTotalPages(response?.data?.totalPages);
          setTotalNumberOfRows(response?.data?.numberOfRows);
        }
      })
      .catch((error) => {
        setSearchRoleData([]);
        return error;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    if (searchValue) {
      fetchSearchRoleData();
    } else {
      fetchRoleData();
    }
  }, [currentPage, customPageSize, sortOrder, columnName, searchValue]);

  return (
    <div className="page-content">
      <div className="flex-grow-1 mx-3">
        <div className="mb-1 mx-2 d-flex justify-content-between align-items-center">
          <span className="fs-4 d-flex gap-4">{RoleLabel} </span>
          <div className="d-flex align-items-center gap-2">
            <BaseButton
              className="btn btn-success"
              onClick={() => navigate("/addRole")}
              children={
                <>
                  <i className="mdi mdi-plus" /> {NewLabel}
                </>
              }
            />
          </div>
        </div>
        <div className="card py-2 px-4 ">
          {loader || roleData.length > 0 ? (
            <TableContainer
              customPageSize={customPageSize}
              setCustomPageSize={setCustomPageSize}
              isGlobalFilter={true}
              columns={columns}
              data={searchValue ? searchRoleData : roleData || []}
              tableLoader={loader}
              tableClass="table bg-white"
              manualPagination={true}
              manualFiltering={true}
              hasManualPagination={true}
              SearchPlaceholder={Search}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={totalPages}
              totalRecords={totalRecords}
              totalNumberOfRows={totalNumberOfRows}
              onSearch={handleSearchValueChange}
              fetchData={handleFetchData}
              fetchSortingData={handleFetchSorting}
            />
          ) : (
            <div className="py-4 text-center">
              <div>
                <span className="fs-1 text-success">
                  <RiSearchLine />
                </span>
              </div>
              <div className="mt-4">
                <h5>{notFound.dataNotFound}</h5>
                <p className="text-muted">{notFound.thereIsNoDataFound}</p>
              </div>
            </div>
          )}
        </div>
        <DeleteModal
          btnLoader={Boolean(btnLoader)}
          onCloseClick={() => setDeleteOpen(!deleteOpen)}
          onDeleteClick={() => deletePosition()}
          show={deleteOpen}
        />
        <Modal
          isOpen={isActiveModal}
          toggle={() => setIsActiveModal(!isActiveModal)}
          centered
        >
          <ModalHeader
            toggle={() => setIsActiveModal(!isActiveModal)}
            className="border-bottom pb-2"
          >
            {StatusLabel}
          </ModalHeader>
          <ModalBody>{StatusUpdateMessageLabel}</ModalBody>
          <ModalFooter>
            <BaseButton
              color="success"
              children={submitLabel}
              loader={btnLoader}
              disable={btnLoader}
              onClick={() => handleStatusChange()}
            />
            <BaseButton
              color="danger"
              children={closeLabel}
              onClick={() => setIsActiveModal(!isActiveModal)}
            />
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

export default Role;
